<template>
  <v-dialog v-model="dialog" max-width="280">
    <template v-slot:activator="{ on }">
      <slot v-bind="{ on }"/>
    </template>
    <v-card>
      <v-card-title>Remove {{ item[field] }}?</v-card-title>
      <v-card-text>
        Once you remove this element can't be recover, are you
        sure to remove this element?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="dialog = false">No</v-btn>
        <v-btn color="grey" text @click="confirm">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'delete',
  props: {
    item: Object,
    fields: {
      type: [Array, String],
      default: () => 'name',
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    field() {
      return window._.isArray(this.fields)
        ? this.fields.find(f => this.item[f])
        : this.fields;
    },
  },
  methods: {
    confirm() {
      this.dialog = false;
      this.$emit('confirm');
    },
  },
};
</script>
